import React, { useState } from "react";

// components imports
import UnitsTable from "../../../../../Components/BoltTable/BoltTable";
import EditUnits from "./Components/EditUnits/EditUnits";
import Tooltip from "../../../../../Components/Tooltip/Tooltip";
import Confirm from "../../../../../Components/Popups/Confirm";

// apis imports
import {
  getTransferUnits,
  deleteTransferUnits,
} from "../../../../../services/admin.services";

// library imports
import { FcPlus } from "react-icons/fc";
import AddUnits from "./Components/AddUnits/AddUnits";
import { MdOutlineCancel } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import BoltButton from "../../../../../Components/UI/Buttons/BoltButton";
import { useTranslation } from "react-i18next";

const UnitStock = ({ setSnack }) => {
  const { t } = useTranslation("admin");
  const [transferUnits, setTransferUnits] = useState([]);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [open, setOpen] = useState(false);
  const [openEdit, setEditOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [refresh, setRefresh] = useState();

  const handleOpenAddUnitModal = () => {
    setOpen(true);
  };

  const columns = [
    {
      id: 1,
      label: t("newsletter.code"),
      render: (row) => <>{row?.code ?? "-"}</>,
      width: "200px",
    },
    {
      id: 2,
      label: t("newsletter.name"),
      render: (row) => <>{row?.name ?? "-"}</>,
      width: "200px",
    },
    {
      id: 3,
      label: t("newsletter.action"),
      render: (row) => (
        <>
          <div className="table_action__wrap">
            <Tooltip title={t("newsletter.editDetails")}>
              <div
                className="table_action__btn"
                onClick={() => {
                  setEditOpen(row);
                }}
              >
                <FaRegEdit size={10} />
                {t("common:actions.edit")}
              </div>
            </Tooltip>

            <Tooltip title={t("newsletter.deleteItem")}>
              <div
                className="table_action__btn"
                onClick={() => setConfirmDelete(row)}
              >
                <MdOutlineCancel size={10} />
                {t("common:actions.delete")}
              </div>
            </Tooltip>
          </div>
        </>
      ),

      width: "200px",
    },
  ];

  const fetchUnits = async (page, perPage, filter) => {
    const response = await getTransferUnits(page, perPage, filter);

    if (!response.error) {
      setTransferUnits(response?.data?.result);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  const handleDeleteRequest = async (data) => {
    if (data.id) {
      setLoader(true);
      const response = await deleteTransferUnits(data.id);
      setConfirmDelete(false);
      if (!response.error && response?.data?.success) {
        setTransferUnits((prevTransferUnits) => {
          return {
            ...prevTransferUnits,
            data: prevTransferUnits?.data?.filter((d) => d?.id != data?.id),
          };
        });
        setLoader(false);
        setConfirmDelete(false);
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: t("newsletter.transferUnitDeletedSuccessfully"),
            severity: "success",
          };
        });
      } else {
        setLoader(false);
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: t("newsletter.couldntCancelThisRequest"),
            severity: "error",
          };
        });
      }
    }
  };

  return (
    <>
      <Confirm
        open={confirmDelete}
        setOpen={setConfirmDelete}
        handleConfirm={() => handleDeleteRequest(confirmDelete)}
        text={t("newsletter.confirmDeleteUnit")}
        loader={loader}
      />
      <AddUnits
        setOpen={setOpen}
        open={open}
        setSnack={setSnack}
        setRefresh={setRefresh}
      />
      <EditUnits
        setOpen={setEditOpen}
        open={openEdit}
        setSnack={setSnack}
        setTransferUnits={setTransferUnits}
      />
      <div className="custom__table_size1 actionbtn__needtobe_fixwidth">
        <UnitsTable
          tableTitle={t("newsletter.unitsTitle")}
          tableId="unitTableForAdminNewsletter"
          message={t("newsletter.noUnitsAvailableToDisplay")}
          searchPlaceHolder={t("newsletter.searchUnits")}
          columns={columns}
          data={transferUnits}
          getAllData={fetchUnits}
          refresh={refresh}
          headerButtons={
            <div className="flex gap-1.5 flex-wrap">
              <BoltButton
                icon={FcPlus}
                label={t("newsletter.addUnit")}
                onClick={handleOpenAddUnitModal}
                variant="success"
                size="sm"
              />
            </div>
          }
        />
      </div>
    </>
  );
};

export default UnitStock;
